export default "/images/72b8650b8d39d82256ac4a24a8dc3b92.avif";